import script from "./TestPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TestPage.vue?vue&type=script&setup=true&lang=js"

import "./TestPage.vue?vue&type=style&index=0&id=db89eec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db89eec6"]])

export default __exports__